import LandingPage from "./Components/BinaryStack/BinaryStack";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Projects from "./Components/BinaryStack/Projects";
import Blog, { Blogtype } from "./Components/BinaryStack/Blog";
import Blogs from "./Components/BinaryStack/Blogs";
import DataStructure from "./Components/BinaryStack/DataStructure";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/blogs" element={<Blogs />} />
        <Route path="/blog/:blogid" element={<Blog BlogType={Blogtype.ALL} />} />
        <Route path="/ds" element={<DataStructure />} />
        <Route path="/ds/:blogid" element={<Blog BlogType={Blogtype.DS} />} />
      </Routes>
    </Router>
  );
}

export default App;
